import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UserAvatar } from './UserAvatar';
import { UnreadMessageBadge } from './UnreadMessageBadge';

interface UserHeaderProps {
  nickName?: string;
  name?: string;
  username?: string;
  avatarPath?: string;
  unreadCount: number;
  onAvatarClick?: (event: React.MouseEvent<HTMLElement>) => void;
  onUnreadClick?: () => void;
  avatarVariant?: 'circular' | 'rounded' | 'square';
  avatarBgColor?: string;
}

export const UserHeader: React.FC<UserHeaderProps> = ({
  nickName,
  name,
  username,
  avatarPath,
  unreadCount,
  onAvatarClick,
  onUnreadClick,
  avatarVariant = 'circular',
  avatarBgColor
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const displayName = nickName || name || username || '';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 1.5,
        height: '100%'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-end',
          minWidth: 0,
          gap: 0.25
        }}
      >
        <Typography
          sx={{
            fontSize: '0.875rem',
            fontWeight: 500,
            lineHeight: 1.2,
            maxWidth: 120,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          {displayName}
        </Typography>
        <UnreadMessageBadge
          unreadCount={unreadCount}
          onClick={onUnreadClick}
        />
      </Box>
      <UserAvatar
        nickName={nickName}
        name={name}
        username={username}
        avatarPath={avatarPath}
        onMenuClick={onAvatarClick}
        tooltip={t('tipClickToOpenUserMenu')}
        variant={avatarVariant}
        bgcolor={avatarBgColor}
      />
    </Box>
  );
};
